import { type FC, useDeferredValue, useState } from 'react';
import { Controller } from 'react-hook-form';
import { SearchableInputSelectOpenSearch } from '@components/SearchableInputSelectOpenSearch';
import { ResourceState } from '@domain/schemas/contract.schema';
import { useSubmissionsOpensearch } from '@queries/fetchSubmissions';
import { isEmptyValue } from '@root/helpers';
import type { SubmissionShort } from '@src/queries';

import type { StepProps } from '../types';

const filterFinalSubmissions = (item: SubmissionShort) => {
  return !isEmptyValue(item.name) && item.status === ResourceState.FINAL;
};

export const Step0OpenSearch: FC<StepProps> = ({ control, formValues }) => {
  const [searchText, setSearchText] = useState('');
  const deferredSearchText = useDeferredValue(searchText);
  const {
    data: submissionsPaginated,
    isLoading: isFetchingSubmissions,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
  } = useSubmissionsOpensearch({
    queryFilters: [{ field: 'status', comparator: 'eq', values: ['FINAL'] }],
    search: deferredSearchText,
  });

  const submissions = submissionsPaginated?.pages.flatMap((page) => page.data) ?? [];

  const submissionOptions = submissions.filter(filterFinalSubmissions).map((item) => ({
    name: item.name,
    value: item.id,
  }));

  return (
    <Controller
      control={control}
      render={({ field: { ref: _ref, ...props }, fieldState: { error } }) => (
        <SearchableInputSelectOpenSearch
          {...props}
          errors={error?.message}
          isLoading={isFetchingSubmissions}
          noOptionsLeftLabel="No contracts available"
          labelText="Select a contract to renew"
          placeholder="Search contracts"
          options={submissionOptions}
          value={formValues?.renewFromSubmissionId}
          isFetchingNextPage={isFetchingNextPage}
          fetchNextPage={fetchNextPage}
          searchText={searchText}
          setSearchText={setSearchText}
          hasNextPage={hasNextPage}
        />
      )}
      name="renewFromSubmissionId"
    />
  );
};
